import { PropsWithChildren } from 'react'
import React from 'react'
import { Control } from 'react-hook-form'
import { useIntl } from 'react-intl'

import {
  HouseContext,
  HouseStudyDayGlobalDto,
} from '../../../../../../../../lib/graphql'
import { breakpoints, useMediaQuery } from '../../../../../../../../lib/hooks'
import { Container } from '../../../../../../../layout'
import { HouseOptionsFormLayoutProps } from '../../../../../HouseOptionsForm'
import HouseOptionSubmit, {
  HouseOptionSubmitProps,
} from '../../../../../shared/components/house-options-submit/HouseOptionSubmit'

export type HouseStudyDayGlobalFieldProps = {
  control: Control<HouseStudyDayGlobalDto>
  isFieldDisabled: boolean
  currencyArea: HouseContext['currencyArea']
}

export type HouseStudyDayGlobalFormContainerProps = {
  submitButtons: Omit<HouseOptionSubmitProps, 'className'>
} & Omit<HouseOptionsFormLayoutProps, 'house' | 'isDisabled'>
export const HouseStudyDayGlobalFormContainer = ({
  children,
  handleOnExpand,
  isOpen,
  layoutProps: { numberOfCards, parentHeight },
  submitButtons,
}: PropsWithChildren<HouseStudyDayGlobalFormContainerProps>) => {
  const intl = useIntl()
  const isMobile = useMediaQuery(breakpoints.newMobile)
  return (
    <Container
      title={intl.formatMessage({
        defaultMessage: 'Séjours à la journée',
        id: 'ui.HouseStudyDayGlobalFormContainer.title',
      })}
      isCollapsible={!isMobile}
      isOpened={isOpen}
      toggleCard={handleOnExpand}
      style={{ width: !isMobile ? '100%' : 'auto' }}
      styleTitle={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}
      styleContent={{
        height: '100%',
        paddingRight: '20px',
        paddingLeft: '20px',
      }}
    >
      <div
        style={{
          maxHeight: `calc(${parentHeight}px - ${numberOfCards * 62}px - 30px - 50px - 20px)`,
          overflowX: 'hidden',
        }}
      >
        {children}
      </div>

      <HouseOptionSubmit {...submitButtons} />
    </Container>
  )
}
